import { render, staticRenderFns } from "./employer.vue?vue&type=template&id=85c14c52&scoped=true"
import script from "./employer.vue?vue&type=script&lang=js"
export * from "./employer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c14c52",
  null
  
)

export default component.exports